import React,{useState} from "react";
import { useTranslation } from 'react-i18next';
import {Unsub} from '../../services/api';

const Footer = (props) =>{
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';

    const[email,setEmail]= useState('');
    const[message,setMessage]= useState('');
    const [mailres, setMailRes] = useState('');
    const [isValid, setIsValid] = useState(true); 
    const user_public_id =  props.user_id;
    const hostnames = ['ae', 'bn','lk']
    const has_unsub = hostnames.includes(props.hostname);
  
    const handleEmailChange = (e) => {
        const email = e.target.value;
        setEmail(email);
      };
    
      const handleMessageChange = (e) => {
        const msg = e.target.value;
        setMessage(msg);
      };
    
    
       const isValidEmail = (email) =>{
        const pattern =  /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        return pattern.test(email);
       };

    const sendEmail = async () => {
        setMailRes('');
        setIsValid(isValidEmail(email));
    
        if (isValidEmail(email)) {
          const res = await fetch('http://localhost:8000/api/send-email/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          mode: 'cors',
          body: JSON.stringify({ email: email,message: message }),
        });
         const data = await res.json();
         if(data.status == "success"){
          document.getElementById("email").value = "";
          document.getElementById("message").value = "";
           setMailRes('Sent Successfully!');
         }
        }
    
      };

    const Unsubscribe = async () =>{
      if(user_public_id){
        const formData = new FormData()
        formData.append('user_public_id', user_public_id)
        const response = await Unsub(formData);
        if(response.data.message == 'SUCCESS' && response.data.payload.is_valid){
          window.location.href = '/';
        }
      }
    }
    return(
        <div className="footer pb-3" style={{backgroundColor:"#000000"}}>
            <div className="container">
                <div className="row pt-5">
                    <div className="col-md-6 footer-text-section">
                        <h4 className={`text-light  ${isArabic ? 'notokufi-bold' : 'avenir-heavy'}`}>{t('footer.title')}</h4>
                        <p className={`pt-2 footer-text text-light  ${isArabic ? 'notokufi-regular' : 'avenir-reagular'}`}style={{fontSize:"0.8em"}}>
                        {t('footer.desc')}
                        </p>
                    </div>
                    <div className="footer-form col-md-6 d-flex align-items-end flex-column" >
                        <div className="form-group w-50">
                           <input type="text" className="form-control bg-textboxes" placeholder={t('footer.emailPlaceholder')} id="email" onChange={handleEmailChange} />
                           {!isValid && <p className={` ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`} style={{ color: 'red' }}>{t('footer.invalidemail')}</p>}
                        </div>
                        <div className="form-group mt-2 w-50">
                            <textarea className={`form-control bg-textboxes  ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`} placeholder={t('footer.messagePlaceholder')} rows="3" id="message" onChange={handleMessageChange}/>
                        </div>
                        <button type="button" className={`btn submit-btn  ${isArabic ? 'notokufi-bold' : 'avenir-heavy'}`} onClick={sendEmail}>
                         {t('footer.submit')}
                        </button>
                        {mailres && <p className={` ${isArabic ? 'notokufi-regular' : 'avenir-regular'} mt-3 mb-3`} style={{ color: 'green' }}>{mailres}</p>}
                    </div>
                    <hr className="mt-5" style={{color:"white"}}/>
                </div> 
                <div className={`text-light  ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`} style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span className="copy-right" style={{fontSize:"0.7em"}}>{t('footer.copyright')}</span>
                        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
                          {/* <span className="span-mr " style={{fontSize:"0.8em", marginRight: "60px" }}>{t('footer.FAQ')}</span>
                          <span className="span-mr" style={{fontSize:"0.8em", marginRight: "60px" }}>{t('footer.Blog')}</span> */}
                          <a href='/terms&condition' className="span-mr text-light "  style={{fontSize:"0.8em", marginRight: "60px",textDecoration:'none' }}>{t('footer.terms')}</a>
                          { has_unsub && user_public_id && (
                            <button className="btn span-mr rtl-span text-light"  style={{fontSize:"0.8em", marginRight: "10px" ,padding:0}} onClick={Unsubscribe}>{t('footer.unsubscribe')}</button>
                          )}
                        </span>
                </div>  
            </div>
        </div>
    );
};

export default Footer